var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "123px",
    viewBox: "0 0 123 123",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D720FE9E-0B67-4ACE-BCE1-F5284B727D74") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.03664,114.07328 C47.2592202,114.07328 54.0294615,112.136587 59.8563802,108.754185 C65.1804688,116.47137 60.9712229,124.113918 75.75,122 C102.177875,118.219825 122.659821,85.128638 122.659821,75.7566565 C122.659821,62.3017907 115.305107,10.8965552 105.037234,3.7553976 C98.6416956,-0.692607456 53.0588235,1 38.5841732,1 C24.1095229,1 24.9062937,37.2767568 18.7645903,41.2044484 C7.78126365,48.2284149 0.5,60.5322123 0.5,74.53664 C0.5,96.3721233 18.2011567,114.07328 40.03664,114.07328 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Primary-Navigation-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    transform: "translate(-198.000000, -2276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(-36.000000, 2139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder__leader_leadership_businesswoman_4865018",
    transform: "translate(234.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 40.03664,
    cy: 74.53664,
    r: 39.53664
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.464633, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3572416,33.606383 C64.3572416,33.606383 77.3389129,79.1241989 111.385183,100.433735 C119.223173,79.8590105 140.042835,79.1241989 140.042835,58.7944117 C117.263676,55.6102281 106.486439,34.0962574 90.3205843,33.3614458 C85.4218404,43.1589336 77.2034476,48.2525444 77.2034476,48.2525444 L64.3572416,33.606383 Z",
    id: "Path",
    fill: "#D2DBE5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6773612,27.2143025 C65.0036308,23.6253369 66.3087092,12.8584402 66.6349788,12.205901 C67.9400572,6.65931779 72.8341012,2.09154341 79.0332236,2.09154341 C85.232346,2.09154341 90.4526595,6.65931779 91.4314683,12.5321706 C91.4314683,13.1847098 92.7365467,23.2990673 93.0628163,26.8880329 C93.0628163,27.5405721 92.7365467,28.1931113 92.0840075,28.1931113 L65.65617,28.1931113 C65.0657677,28.1931113 64.5621162,27.8943236 64.6773612,27.2143025 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1687723,16.1211362 C88.1687723,22.9727977 83.9272676,30.1507289 78.706954,30.1507289 C73.4866404,30.1507289 69.2451356,23.2990673 69.2451356,16.1211362 C69.2451356,10.9008226 73.4866404,6.98558739 78.706954,6.98558739 C83.9272676,6.98558739 88.1687723,10.9008226 88.1687723,16.1211362 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1263899,15.468597 C87.1899635,18.731293 80.9908412,16.1211362 77.075606,13.1847098 C72.8341012,10.2482834 73.81291,7.31185699 75.444258,5.0279698 C77.075606,2.7440826 81.6433804,3.0703522 85.8848852,6.00677859 C89.4738507,8.94320499 91.7577379,13.1847098 90.1263899,15.468597 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7705276,10.574553 C75.7705276,10.574553 70.2239444,11.5533618 68.2663268,16.1211362 C66.6349788,14.4897882 68.918866,9.26947459 68.918866,9.26947459 C68.918866,9.26947459 72.181562,4.049161 73.4866404,4.049161 C74.7917188,4.049161 78.0544148,4.7017002 78.0544148,4.7017002 L75.7705276,10.574553 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.918866,151.52302 L64.3510916,91.163144 C64.024822,87.5741784 66.6349788,84.3114824 70.2239444,84.3114824 C73.81291,84.3114824 77.075606,86.5953696 77.075606,90.1843352 C77.075606,90.5106048 77.075606,90.5106048 77.075606,90.8368744 L76.4230668,151.52302 C76.4230668,153.806907 74.7917188,155.438255 72.5078316,155.438255 C70.8764836,155.111985 69.2451356,153.480637 68.918866,151.52302 Z",
    id: "Path",
    fill: "#FC4F5F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6645716,151.19675 L80.0120324,90.5106048 C80.0120324,86.9216392 82.9484588,83.9852128 86.5374243,83.9852128 C90.1263899,83.9852128 93.0628163,86.9216392 93.0628163,90.5106048 C93.0628163,90.8368744 93.0628163,90.8368744 93.0628163,91.163144 L88.4950419,151.52302 C88.4950419,153.806907 86.5374243,155.111985 84.2535372,155.111985 C82.2959196,155.111985 80.6645716,153.154368 80.6645716,151.19675 Z",
    id: "Path",
    fill: "#FC4F5F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 69.2451356,
    y: 33.2684162,
    width: 17.2922888,
    height: 21.7301081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2747284,58.2099144 L79.3594932,37.3286601 C79.3594932,36.6761209 78.0544148,36.6761209 78.0544148,37.3286601 L74.1391796,58.2099144 L75.7705276,65.7141152 L81.6433804,65.3878456 L83.2747284,58.2099144 Z",
    id: "Path",
    fill: "#D9163C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2831299,45.4854001 L96.3255123,38.3074689 C95.6729731,35.3710425 93.0628163,33.4134249 90.1263899,33.4134249 L83.600998,33.4134249 L85.232346,44.5065913 L78.706954,50.7057137 L72.181562,44.5065913 L73.81291,33.4134249 L67.287518,33.4134249 C64.3510916,33.4134249 61.7409348,35.3710425 61.0883956,38.3074689 L59.130778,45.4854001 C59.130778,45.4854001 65.65617,62.4514192 65.0036308,66.0403848 L59.4570476,91.163144 C59.4570476,91.8156832 59.7833172,92.4682224 60.4358564,92.4682224 C72.8341012,94.4258399 84.9060764,94.4258399 97.3043211,92.4682224 C97.9568603,92.4682224 98.2831299,91.8156832 98.2831299,91.163144 L92.4102771,66.0403848 C91.7577379,62.4514192 98.2831299,45.4854001 98.2831299,45.4854001 Z",
    id: "Path",
    fill: "#FC4F5F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8552924,42.2227041 L57.1731604,67.6717328 L57.1731604,63.7564976 L65.65617,81.7013256 C66.3087092,83.006404 65.65617,84.637752 64.3510916,85.2902912 C63.0460132,85.9428304 61.7409348,85.2902912 60.762126,84.3114824 L49.6689597,67.6717328 C49.0164205,66.692924 49.0164205,65.3878456 49.3426901,64.0827672 L49.6689597,63.430228 L61.7409348,36.6761209 C63.0460132,33.7396945 66.3087092,32.4346161 69.2451356,33.7396945 C72.181562,35.0447729 73.4866404,38.3074689 72.181562,41.2438953 C71.8552924,41.8964345 71.8552924,41.8964345 71.8552924,42.2227041 Z",
    id: "Path",
    fill: "#FC4F5F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.847201,7.20274158 L109.534932,11.7033563 C109.722458,12.0784075 110.097509,12.4534587 110.47256,12.6409843 L114.973175,14.3287149 C115.723277,14.5162405 115.723277,15.6413941 114.973175,15.8289198 L110.47256,17.5166503 C110.097509,17.7041759 109.722458,18.0792271 109.534932,18.4542783 L107.847201,22.954893 C107.659676,23.7049955 106.534522,23.7049955 106.346997,22.954893 L104.659266,18.4542783 C104.47174,18.0792271 104.096689,17.7041759 103.721638,17.5166503 L99.2210232,15.8289198 C98.4709208,15.6413941 98.4709208,14.5162405 99.2210232,14.3287149 L103.721638,12.6409843 C104.096689,12.4534587 104.47174,12.0784075 104.659266,11.7033563 L106.346997,7.20274158 C106.722048,6.45263913 107.659676,6.45263913 107.847201,7.20274158 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.411417,0.445426604 L121.536571,3.25831079 C121.724097,3.44583641 121.911622,3.82088763 122.099148,3.82088763 L124.912032,4.94604131 C125.287083,5.13356692 125.287083,5.69614376 124.912032,5.88366937 L122.286674,7.19634866 C122.099148,7.38387427 121.724097,7.57139989 121.724097,7.7589255 L120.411417,10.5718097 C120.223892,10.9468609 119.661315,10.9468609 119.473789,10.5718097 L118.348636,7.7589255 C118.16111,7.57139989 117.973585,7.19634866 117.786059,7.19634866 L114.785649,5.88366937 C114.410598,5.69614376 114.410598,5.13356692 114.785649,4.94604131 L117.598533,3.82088763 C117.786059,3.63336202 118.16111,3.44583641 118.16111,3.25831079 L119.286264,0.445426604 C119.661315,-0.117150234 120.223892,-0.117150234 120.411417,0.445426604 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9992427,37.0023905 L108.071218,63.7564976 L108.397487,64.0827672 C109.050027,65.3878456 108.723757,66.692924 108.071218,67.6717328 L96.9780515,84.3114824 C95.9992427,85.6165608 94.3678947,85.9428304 93.0628163,84.9640216 C91.7577379,84.3114824 91.4314683,82.6801344 92.0840075,81.375056 L100.567017,63.430228 L100.567017,67.3454632 L85.8848852,41.8964345 C84.2535372,39.2862777 85.232346,35.6973121 87.8425027,34.0659641 C90.4526595,32.4346161 94.0416251,33.4134249 95.6729731,36.0235817 C95.6729731,36.6761209 95.6729731,37.0023905 95.9992427,37.0023905 Z",
    id: "Path",
    fill: "#FC4F5F",
    fillRule: "nonzero"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.89ad536b968f3008242031eb0b0a8e67.svg";
export { ForwardRef as ReactComponent };